import React from 'react';
import ReactDOM from 'react-dom';
import * as emailjs from 'emailjs-com';
import './index.css';
import App from './App';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers';
import { createTracker } from 'redux-segment';

const tracker = createTracker();

const store = createStore(
  rootReducer,
  applyMiddleware(
    thunk,
    logger,
    tracker
  )
);

emailjs.init('user_pc7oPqBiSVjwbt7k4uPMH');

ReactDOM.render((
  <Provider store={store}>
    <App />
  </Provider>
), document.getElementById('root'));

